// extracted by mini-css-extract-plugin
export default {"icon":"Az5ze"};